import axios from 'axios';

// Pull from environment variables, fallback to localhost for safety
const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Auto-inject JWT Token from localStorage
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Catch unauthorized access (401) and auto-redirect to login
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// --- ENDPOINTS ---

export const authAPI = {
  login: (email, password) => apiClient.post('/auth/login', { email, password }),
};

export const orderAPI = {
  create: (orderData) => apiClient.post('/orders/', orderData),
  list: (params) => apiClient.get('/orders/', { params }), 
  getById: (orderId, shop) => apiClient.get(`/orders/${orderId}`, { params: { shop } }),
  update: (orderId, shop, updateData) => apiClient.put(`/orders/${orderId}`, updateData, { params: { shop } }),
  delete: (orderId, shop) => apiClient.delete(`/orders/${orderId}`, { params: { shop } }),
  
  suggestTargetDate: (itemType, priority, pickupDate) =>
    apiClient.get('/orders/suggest-target-date', { 
      params: { item_type: itemType, priority, pickup_date: pickupDate } 
    }),
  filterOrders: (params) => apiClient.get('/orders/filter', { params }),
  search: (searchTerm, shop) => apiClient.get('/orders/search', { params: { q: searchTerm, shop } }),
};

export const statusAPI = {
  updateStatus: (orderId, shop, payload) => apiClient.put(`/orders/${orderId}/status`, payload, { params: { shop } }),
};

export const itemAPI = {
  addItem: (orderId, shop, itemData) => apiClient.post(`/orders/${orderId}/items`, itemData, { params: { shop } }),
  updateItem: (orderId, itemId, shop, itemData) => apiClient.put(`/orders/${orderId}/items/${itemId}`, itemData, { params: { shop } }),
  removeItem: (orderId, itemId, shop) => apiClient.delete(`/orders/${orderId}/items/${itemId}`, { params: { shop } }),
};

export const dashboardAPI = {
  getSummary: (shop) => apiClient.get('/dashboard/summary', { params: { shop } }),
};

export const notificationAPI = {
  getSettings: () => apiClient.get('/notifications/settings'),
  updateSettings: (status, isEnabled) => apiClient.put(`/notifications/settings/${status}`, { is_enabled: isEnabled }),
  getLogs: (orderId = null, limit = 100) => apiClient.get('/notifications/logs', { params: { order_id: orderId, limit } }),
};

export default apiClient;